import { render, staticRenderFns } from "./MTVNav.vue?vue&type=template&id=501cb32b&scoped=true&"
import script from "./MTVNav.vue?vue&type=script&lang=js&"
export * from "./MTVNav.vue?vue&type=script&lang=js&"
import style0 from "./MTVNav.vue?vue&type=style&index=0&id=501cb32b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cb32b",
  null
  
)

export default component.exports